import { render } from "./EditSpecificModal.vue?vue&type=template&id=57042ece&scoped=true"
import script from "./EditSpecificModal.vue?vue&type=script&lang=js"
export * from "./EditSpecificModal.vue?vue&type=script&lang=js"

import "./EditSpecificModal.vue?vue&type=style&index=0&id=57042ece&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57042ece"]])

export default __exports__